import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Icon, Header, Loader, Message, Dimmer } from 'semantic-ui-react';

const PaymentConfirmation = ({ policies, sources, actions, setLoading, loading, onPaymentComplete }) => {
	const [confirmation, setConfirmation] = useState(null);

	useEffect(() => {
		const makePayment = async () => {
			try {
				setLoading(true);

				sources.forEach(source => {
					source.type = source.type === 'check' ? 'check' : 'credit';
				});
				const result = await actions.submitPayment(policies, sources);
				setConfirmation(result.response.confirmation);
				setLoading(false);

				if (onPaymentComplete) onPaymentComplete(result.response.confirmation);
            } catch (error) {
				const conf = { error: error.message }
				setConfirmation(conf);
				setLoading(false);
				
				if (onPaymentComplete) onPaymentComplete(conf);
			}
		};

		makePayment();
	}, [actions, policies, setLoading, sources, onPaymentComplete]);

	return (
		<div className='post-payment-confirmation'>
			{confirmation && !confirmation.error && (
				<React.Fragment>
					{confirmation.map((item, index) => (
						<p key={index}>
							Confirmation ({item.accountNumber || item.policyNumber}): {item.paymentConfirmationNumber || item.error}
						</p>
					))}

					{confirmation.some(item => item.error) && (
						<React.Fragment>
							<Icon name='times circle outline' size='massive' color='red' />
							<Header as='h1' content='Failed!' />
							<p>One or more payments failed!</p>
						</React.Fragment>
					)}

					{!confirmation.some(item => item.error) && (
						<React.Fragment>
							<Icon name='check circle' size='massive' color='green' />
							<Header as='h1' content='Success!' />
						</React.Fragment>
					)}
				</React.Fragment>
			)}

			{confirmation && confirmation.error && (
				<React.Fragment>
					<Message error>Error: {confirmation.error}</Message>
					<Icon name='times circle outline' size='massive' color='red' />
					<Header as='h1' content='Failed!' />
				</React.Fragment>
			)}

			{!confirmation && loading && (
				<div>
					<Dimmer active inverted>
						<Loader active size='massive'>
							Submitting Payment...
						</Loader>
					</Dimmer>
				</div>
			)}
		</div>
	);
};

PaymentConfirmation.propTypes = {
	confirmation: PropTypes.object
};

export default PaymentConfirmation;
